// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.result-modal__key[data-v-730f1a38] {\n  white-space: nowrap;\n  vertical-align: top;\n  font-weight: 500;\n}\n.result-modal__value[data-v-730f1a38] {\n  font-family: 'Roboto Mono', Menlo, Consolas, monospace;\n  font-size: 12px;\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n", ""]);
// Exports
module.exports = exports;
